import React from "react"

// A Rendered listing source's link pattern, shared by its edit and view panels. The edit panel writes the pattern
// from the groups of links ticked (dashboard-api's rendered_listing_discover generates each group's), and the view
// shows it as those groups' shapes again.

// A link shape or pattern, in the surrounding text's colour: Bootstrap's pink <code> reads as an error here. The
// faint background works on white and inside the amber boxes.
export const Code = ({ children }) => (
    <code
        style={{
            color: "inherit",
            background: "rgba(0, 0, 0, 0.06)",
            padding: "1px 4px",
            borderRadius: "3px",
        }}
    >
        {children}
    </code>
)

// The groups' patterns the link pattern is made of: one group's pattern, or several as (?:a|b). Groups' patterns
// never contain "|", so splitting on it is safe.
export const patternParts = (linkPattern) => {
    const pattern = (linkPattern || "").trim()
    return pattern.startsWith("(?:") && pattern.endsWith(")")
        ? pattern.slice(3, -1).split("|")
        : [pattern]
}

export const combinePatterns = (patterns) =>
    patterns.length > 1 ? `(?:${patterns.join("|")})` : patterns[0] || ""

// How dashboard-api's shape_pattern writes a shape such as weforum.org/stories/*/*: either scheme, with or without
// "www.", the escaped site and path with one ANY_PART per "*", then an optional trailing slash and query string
const PREFIX = "https?://(?:www\\.)?"
const SUFFIX = "/?(?:\\?.*)?"
const ANY_PART = "/[^/?#]+"
// Text Python's re.escape wrote: escaped characters, and no regex syntax of its own
const ESCAPED_TEXT = /^(?:\\.|[^\\.^$*+?()[\]{}|])*$/

const shapeOf = (pattern) => {
    if (!pattern.startsWith(PREFIX) || !pattern.endsWith(SUFFIX)) {
        return null
    }
    const literals = pattern
        .slice(PREFIX.length, -SUFFIX.length)
        .split(ANY_PART)
    return literals.every((literal) => ESCAPED_TEXT.test(literal))
        ? literals.map((literal) => literal.replace(/\\(.)/g, "$1")).join("/*")
        : null
}

// The shapes a link pattern was written from, or null if any part of it was written by hand
export const shapesOf = (linkPattern) => {
    const shapes = patternParts(linkPattern).map(shapeOf)
    return shapes.every(Boolean) ? shapes : null
}
